export const buildFileFormData = (file: File, fieldName: string): FormData => {
  const formData = new FormData();
  formData.append(fieldName, file);
  return formData;
};
